/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Professional_No_IndustryInputs */



/**
* | output |
* | --- |
* | "No industry found." |
*
* @param {Profile_Professional_No_IndustryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_professional_no_industry = /** @type {((inputs?: Profile_Professional_No_IndustryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Professional_No_IndustryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Branche gefunden.")
	return /** @type {LocalizedString} */ ("No industry found.")
});